import * as HeroIcons from '@heroicons/react/24/outline';
import { Button } from "../../../../components/ui/button"
import { DataTableColumnHeader } from "../../../../components/ui/data-table-column-header"
import { Badge } from "../../../../components/ui/badge";
import { formatLastLogin } from 'lib/utils';

const createStandardHeader = (title: string) => () => (
  <div className="text-xs font-medium text-gray-700">{title}</div>
);

export const createUsersColumns = (onDeleteUser: (user: any) => void, onEditUser: (user: any) => void) => [
  {
    accessorKey: "name",
    header: ({ column }: any) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }: any) => (
      <div className="font-medium text-xs">{row.getValue("name") || "Unknown User"}</div>
    ),
    enableSorting: true,
    enableHiding: false,
  },
  {
    accessorKey: "mobile_no",
    header: createStandardHeader("Mobile Number"),
    cell: ({ row }: any) => <div className="text-xs">{row.getValue("mobile_no") || "-"}</div>,
    enableSorting: false,
  },
  {
    accessorKey: "email",
    header: ({ column }: any) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }: any) => <div className="text-xs">{row.getValue("email") || "-"}</div>,
    enableSorting: true,
  },
  {
    accessorKey: "cust_name",
    header: ({ column }: any) => (
      <DataTableColumnHeader column={column} title="Customer" />
    ),
    cell: ({ row }: any) => <div className="text-xs">{row.getValue("cust_name") || "-"}</div>,
    enableSorting: true,
  },
  {
    accessorKey: "role_name",
    header: createStandardHeader("Role"),
    cell: ({ row }: any) => {
      const roleName = row.getValue("role_name");
      return (
        <Badge variant="secondary" className="text-xs">
          {roleName || "No Role"}
        </Badge>
      );
    },
    enableSorting: false,
  },
  {
    accessorKey: "last_login_at",
    header: ({ column }: any) => (
      <DataTableColumnHeader column={column} title="Last Login" />
    ),
    cell: ({ row }: any) => (
      <div className="text-xs">
        {formatLastLogin(row.getValue("last_login_at"))}
      </div>
    ),
    enableSorting: true,
  },
  {
    id: "actions",
    header: createStandardHeader("Actions"),
    cell: ({ row }: any) => {
      const user = row.original;
      return (
        <div className="flex gap-1">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEditUser(user)}
            className="h-7 px-2.5 py-1 text-xs bg-blue-100 text-blue-600 border-blue-200 hover:bg-blue-200 hover:text-blue-700"
          >
            <HeroIcons.PencilSquareIcon className="h-4 w-4 mr-1" />
            Edit
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onDeleteUser(user)}
            className="h-7 px-2.5 py-1 text-xs bg-red-100 text-red-600 border-red-200 hover:bg-red-200 hover:text-red-700"
          >
            <HeroIcons.TrashIcon className="h-4 w-4 mr-1" />
            Delete
          </Button>
        </div>
      );
    },
    enableSorting: false,
    enableHiding: false,
  },
]
